import React, { useMemo, useState } from "react";
import { cn } from "utils";
import ChevronLeft from "assets/images/icon/chevron-left";
import ChevronRight from "assets/images/icon/chevron-right";
import IconButton from "./IconButton";

const Pagination = React.forwardRef(({
    totalPages = 2,
    currentPage = 1,
    className,
    style,
    ...rest
}, ref) => {
    const [selectedPage, setSelectedPage] = useState(currentPage);

    const pagesArr = useMemo(() => {
        const arr = [];
        let count = 1;
        while (count <= totalPages) {
            arr.push(count);
            count += 1;
        }
        return arr;
    }, [totalPages])
    return (
        <div
            ref={ref}
            className={cn("pagination-container", className)}
            style={{ ...style }}
            {...rest}
        >
            <div className="pagination">
                <IconButton
                    onClick={() => setSelectedPage((prev) => prev - 1)}
                    disabled={selectedPage === 1}
                >
                    <ChevronLeft />
                </IconButton>
                {pagesArr.map((pageNum) => {
                    return (
                        <button
                            className={cn("page_number", selectedPage === pageNum ? "active" : "inactive")}
                            onClick={() => setSelectedPage(pageNum)}
                        >
                            {pageNum}
                        </button>
                    )
                })}
                <IconButton
                    onClick={() => setSelectedPage((prev) => prev + 1)}
                    disabled={selectedPage === totalPages}
                >
                    <ChevronRight />
                </IconButton>
            </div>
        </div>
    )
})

export default Pagination;